(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-design-system"] && !Shopify.designMode) return;
  try {
    class DDCollection extends HTMLElement {
    connectedCallback() {
      if (document.documentElement.dataset.ddTrending === 'true') return;
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('[data-dd-results]');
      this.button = this.querySelector('[data-dd-load-more]');
      this.status = this.querySelector('[data-dd-result-status]');
      this.empty = this.querySelector('[data-dd-empty]');
      this.form = this.querySelector('form');
      this.dialog = this.querySelector('dialog');
      this.cards = Array.from(this.grid.querySelectorAll('[data-dd-card]'));
      this.limit = 24;
      this.next = this.button.getAttribute('href') || '';
      const selected = new URL(location.href).searchParams.get('dd_format');
      this.format = ['all','digital','physical'].includes(selected) ? selected : this.dataset.defaultFormat;
      this.categorySelect = this.querySelector('[data-dd-category]');
      const category = new URL(location.href).searchParams.get('dd_category');
      this.category = Array.from(this.categorySelect.options).some(option => option.value === category) ? category : 'all';
      this.categorySelect.value = this.category;
      this.categorySelect.dispatchEvent(new Event('dd:selection-sync'));
      document.documentElement.dataset.ddFormat = this.format;
      this.querySelector('[data-dd-format-input]').value = this.format;
      this.querySelectorAll('[data-dd-format-link]').forEach(link => {
        const format = link.dataset.ddFormatLink;
        if (format === this.format) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
        const href = new URL(link.href);
        const current = new URL(location.href);
        current.pathname = href.pathname;
        current.searchParams.set('dd_format',format);
        current.searchParams.set('dd_category',this.category);
        current.searchParams.delete('page');
        link.href = current.toString();
      });
      this.querySelectorAll('.dd-active-filter').forEach(link => {
        const href = new URL(link.href);
        href.searchParams.set('dd_format',this.format);
        href.searchParams.set('dd_category',this.category);
        link.href = href.toString();
      });
      this.button.addEventListener('click', event => {
        event.preventDefault();
        if (this.busy) return;
        this.limit += 24;
        this.fill();
      });
      this.querySelector('[data-dd-open-filter]').addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-dd-close-filter]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => this.querySelector('[data-dd-open-filter]').focus());
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submitFilters(); });
      this.querySelector('[data-dd-sort]').addEventListener('change', () => this.submitFilters());
      this.categorySelect.addEventListener('change', () => this.submitFilters());
      const reset = this.querySelector('[data-dd-reset]');
      const resetUrl = new URL(reset.href);
      resetUrl.searchParams.set('dd_format',this.format);
      reset.href = resetUrl.toString();
      this.renderCards();
      this.fill();
    }
    matchesCard(card) {
      const formatMatches = this.format === 'all' || card.dataset.format === this.format || card.dataset.format === 'mixed';
      const categoryMatches = this.category === 'all' || (card.dataset.categories || '').split(/\s+/).includes(this.category);
      return formatMatches && categoryMatches;
    }
    matchingCards() {
      return this.cards.filter(card => this.matchesCard(card));
    }
    renderCards() {
      let visible = 0;
      this.cards.forEach(card => {
        const match = this.matchesCard(card);
        card.hidden = !match || visible >= this.limit;
        if (!card.hidden) visible++;
      });
      const more = this.matchingCards().length > this.limit || Boolean(this.next);
      this.button.hidden = !more;
      this.empty.hidden = visible > 0 || Boolean(this.next) || this.busy;
      if (this.next) this.button.href = this.next;
      return visible;
    }
    async fill() {
      if (this.busy) return;
      this.busy = true;
      this.button.setAttribute('aria-disabled','true');
      this.grid.setAttribute('aria-busy','true');
      let passes = 0;
      try {
        while (this.matchingCards().length < this.limit && this.next && passes < 12 && this.isConnected) {
          passes++;
          this.status.textContent = this.dataset.loading;
          const url = new URL(this.next,location.href);
          if (url.origin !== location.origin) throw new Error('Invalid pagination origin');
          url.searchParams.set('section_id',this.dataset.sectionId);
          url.searchParams.set('dd_format',this.format);
          url.searchParams.set('dd_category',this.category);
          const response = await fetch(url.toString(),{credentials:'same-origin'});
          if (!response.ok) throw new Error('Collection request failed');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const section = html.querySelector('dd-collection');
          if (!section) throw new Error('Collection section missing');
          const seen = new Set(this.cards.map(card => card.dataset.productId));
          section.querySelectorAll('[data-dd-card]').forEach(card => {
            if (!seen.has(card.dataset.productId)) {
              seen.add(card.dataset.productId);
              this.grid.append(card);
              this.cards.push(card);
            }
          });
          const next = section.querySelector('[data-dd-load-more]');
          const previous = this.next;
          this.next = next && !next.hidden ? next.getAttribute('href') || '' : '';
          if (this.next === previous) this.next = '';
          this.renderCards();
        }
        this.status.textContent = '';
      } catch (error) {
        this.status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-disabled');
        this.grid.removeAttribute('aria-busy');
        const visible = this.renderCards();
        if (!visible && this.next && !this.status.textContent) this.status.textContent = this.dataset.loading;
      }
    }
    submitFilters() {
      const url = new URL(this.form.action);
      for (const [key,value] of new FormData(this.form)) {
        if (String(value).trim()) url.searchParams.append(key,value);
      }
      url.searchParams.set('dd_format',this.format);
      location.assign(url.toString());
    }
  }
  if (!customElements.get('dd-collection')) customElements.define('dd-collection',DDCollection);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-dd-size-guide]');
    if (!link) return;
    const detail = document.getElementById(link.hash.slice(1));
    if (!detail) return;
    event.preventDefault();
    detail.hidden = false;
    detail.open = true;
    detail.querySelector('summary')?.focus({preventScroll:true});
    requestAnimationFrame(() => {
      detail.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-mobile-pickers"] && !Shopify.designMode) return;
  try {
    class DDMobilePickers extends HTMLElement {
    static nextId = 0;
    connectedCallback() {
      if (this.records) return;
      const scope = this.closest('.shopify-section');
      if (!scope || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
      this.media = matchMedia('(max-width: 749px)');
      this.sheet = document.createElement('dialog');
      this.sheet.className = 'dd-choice-sheet';
      this.sheet.id = `dd-choice-sheet-${++DDMobilePickers.nextId}`;
      const header = document.createElement('header');
      this.heading = document.createElement('h2');
      this.heading.id = `${this.sheet.id}-title`;
      this.sheet.setAttribute('aria-labelledby',this.heading.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'dd-choice-close';
      close.setAttribute('aria-label',this.dataset.close);
      close.textContent = '×';
      close.addEventListener('click', () => this.sheet.close());
      header.append(this.heading,close);
      this.list = document.createElement('div');
      this.list.className = 'dd-choice-list';
      this.sheet.append(header,this.list);
      document.body.append(this.sheet);
      this.records = Array.from(scope.querySelectorAll('.dd-category select,.dd-sort select'), (select,index) => {
        const label = select.closest('label');
        const originalFor = label.getAttribute('for');
        const originalId = select.id;
        const title = select.getAttribute('aria-label') || label.querySelector('span')?.textContent.trim() || '';
        if (!select.id) select.id = `${this.sheet.id}-select-${index}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dd-picker-trigger';
        button.id = `${select.id}-trigger`;
        button.setAttribute('aria-haspopup','dialog');
        button.setAttribute('aria-controls',this.sheet.id);
        button.setAttribute('aria-expanded','false');
        const text = document.createElement('span');
        const chevron = document.createElement('span');
        chevron.className = 'dd-picker-chevron';
        chevron.setAttribute('aria-hidden','true');
        button.append(text,chevron);
        const record = {select,label,button,text,title,originalFor,originalId};
        record.sync = () => {
          text.textContent = select.selectedOptions[0]?.textContent || '';
          button.setAttribute('aria-label',`${title.replace(/:$/,'')}: ${text.textContent}`);
          button.disabled = select.disabled;
        };
        button.addEventListener('click', () => this.open(record));
        select.addEventListener('change',record.sync);
        select.addEventListener('dd:selection-sync',record.sync);
        select.after(button);
        select.setAttribute('data-dd-picker-native','');
        record.sync();
        return record;
      });
      this.resize = () => {
        if (!this.media.matches && this.sheet.open) this.sheet.close();
        this.records.forEach(record => { record.label.htmlFor = this.media.matches ? record.button.id : record.select.id; record.sync(); });
      };
      this.media.addEventListener('change',this.resize);
      this.resize();
      this.sheet.addEventListener('close', () => {
        if (!this.activeRecord) return;
        this.activeRecord.button.setAttribute('aria-expanded','false');
        const target = this.media.matches ? this.activeRecord.button : this.activeRecord.select;
        if (target.isConnected) target.focus({preventScroll:true});
      });
      this.sheet.addEventListener('click', event => {
        if (event.target !== this.sheet) return;
        const rect = this.sheet.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.sheet.close();
      });
    }
    open(record) {
      if (!this.media.matches || record.select.disabled) return;
      this.activeRecord = record;
      record.sync();
      this.heading.textContent = record.title.replace(/:$/,'');
      this.list.replaceChildren();
      let selected;
      Array.from(record.select.options).forEach(option => {
        if (option.hidden) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dd-choice-option';
        button.textContent = option.textContent;
        button.disabled = option.disabled || option.parentElement.disabled === true;
        button.setAttribute('aria-pressed',String(option.selected));
        if (option.selected && !button.disabled) selected = button;
        button.addEventListener('click', () => {
          const changed = record.select.value !== option.value;
          record.select.value = option.value;
          record.sync();
          this.sheet.close();
          if (changed) record.select.dispatchEvent(new Event('change',{bubbles:true}));
        });
        this.list.append(button);
      });
      this.sheet.showModal();
      record.button.setAttribute('aria-expanded','true');
      (selected || this.list.querySelector('button:not(:disabled)'))?.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (!this.records) return;
      this.media.removeEventListener('change',this.resize);
      this.sheet.remove();
      this.records.forEach(record => {
        record.select.removeEventListener('change',record.sync);
        record.select.removeEventListener('dd:selection-sync',record.sync);
        record.select.removeAttribute('data-dd-picker-native');
        record.button.remove();
        if (record.originalFor === null) record.label.removeAttribute('for'); else record.label.setAttribute('for',record.originalFor);
        if (!record.originalId) record.select.removeAttribute('id');
      });
      this.records = null;
    }
  }
  if (!customElements.get('dd-mobile-pickers')) customElements.define('dd-mobile-pickers',DDMobilePickers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-supplies-collection"] && !Shopify.designMode) return;
  try {
    class DDSuppliesCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.dialog = this.querySelector('dialog');
      this.grid = this.querySelector('[data-dd-results]');
      this.more = this.querySelector('[data-dd-load-more]');
      this.status = this.querySelector('[data-dd-result-status]');
      const opener = this.querySelector('[data-dd-open-filter]');
      opener.addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-dd-close-filter]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => opener.focus());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.querySelectorAll('[data-dd-supply-navigation]').forEach(select => select.addEventListener('change', () => {
        const url = new URL(select.value, location.href);
        const current = new URL(location.href);
        for (const [key,value] of current.searchParams) {
          if (key.startsWith('filter.') || ['sort_by','preview_theme_id','pb'].includes(key)) url.searchParams.append(key,value);
        }
        location.assign(url.toString());
      }));
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submitFilters(); });
      this.querySelector('[data-dd-sort]').addEventListener('change', () => this.submitFilters());
      this.more.addEventListener('click', event => { event.preventDefault(); this.loadMore(); });
    }
    submitFilters() {
      const url = new URL(this.form.action);
      for (const [key,value] of new FormData(this.form)) if (String(value).trim()) url.searchParams.append(key,value);
      location.assign(url.toString());
    }
    async loadMore() {
      if (this.busy || this.more.hidden) return;
      this.busy = true;
      this.more.setAttribute('aria-disabled','true');
      this.grid.setAttribute('aria-busy','true');
      this.status.textContent = this.dataset.loading;
      try {
        const url = new URL(this.more.href);
        if (url.origin !== location.origin) throw new Error('Invalid pagination origin');
        url.searchParams.set('section_id',this.dataset.sectionId);
        const response = await fetch(url.toString(),{credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const section = html.querySelector('dd-supplies-collection');
        if (!section) throw new Error('Supplies collection missing');
        const seen = new Set(Array.from(this.grid.querySelectorAll('[data-dd-card]'),card => card.dataset.productId));
        section.querySelectorAll('[data-dd-results] [data-dd-card]').forEach(card => {
          if (!seen.has(card.dataset.productId)) { seen.add(card.dataset.productId); this.grid.append(card); }
        });
        const next = section.querySelector('[data-dd-load-more]');
        this.more.hidden = !next || next.hidden;
        if (!this.more.hidden) this.more.href = new URL(next.getAttribute('href'),location.href).toString();
        this.status.textContent = '';
      } catch (error) {
        this.status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        this.more.removeAttribute('aria-disabled');
        this.grid.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('dd-supplies-collection')) customElements.define('dd-supplies-collection', DDSuppliesCollection);
  } catch(e) { console.error(e); }
})();

})();
